var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.notfound",
  title: "EGT 404",
  description: "Branded 404 — links home and to the Codex.",
  supportServer: true
});
var S = require("../helpers/egt.sections.js");

exports.render = async function render() {
  return S.page("/reserve", [
    { n: "section", c: "egt-section egt-canvas egt-canvas--center egt-canvas--tall egt-nf",
      i: [
        S.media({ img: "/imgs/egt-platform-canvas.jpg", alt: "", priority: true, parallax: 0.08 }),
        { n: "div", c: "egt__shell egt-canvas__inner",
          i: S.glass({ width: "narrow", c: "egt-nf__card", content: [
            { n: "p", c: "egt__eyebrow egt-reveal", i: "404" },
            { n: "h1", c: "egt-phero__title egt-reveal",
              i: [ "Lost in ", { n: "span", c: "egt__gold", i: "the universe." } ] },
            { n: "p", c: "egt-phero__lead egt-reveal",
              i: "That page drifted out of orbit. Let's get you back." },
            { n: "div", c: "egt-phero__actions egt-reveal egt-nf__actions",
              i: [ S.cta("/", "Return home"), S.cta("/legal/codex", "Read the Codex") ] }
          ] }) }
      ] }
  ]);
};
